import { Inject, Injectable } from '@angular/core';
import { EsriRequest } from '../../config/esri.module';
import { CONSTANTS } from '../../config/constants.module';
import {from, Observable} from 'rxjs';
import {map} from "rxjs/operators";

/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class LayerInfosService
 * @description The LayerInfosService provides the layer information from the ArcGis-Server.
 */
@Injectable({
  providedIn: 'root',
})
export class LayerInfosService {
  private _layerInfosPool: any[] = [];

  constructor(@Inject(CONSTANTS) private CONST: any) {}

  /**
   * @function getLayerInfos
   * @param url
   * @returns {Observable<any>}
   * @description Returns the layer-infos
   */
  public getLayerInfos(url: string): Observable<any> {
    // check of already loaded layer infos
    const poolItems = this._layerInfosPool.filter(f => f.url === url);
    if (poolItems.length > 0) {
      return from([poolItems[0]]);
    }

    // load layer infos
    return this.loadLayerInfos(url).pipe(
      map((result: any) => {
        this._layerInfosPool.push(result);
        return result;
      })
    );
  }

  /**
   * @name loadLayerInfo
   * @returns {any}
   * @description Loads the layer infos
   */
  private loadLayerInfos(url: string): Observable<any> {
    const options = {
      query: {
        f: 'json',
      },
      responseType: 'json',
    } as __esri.RequestOptions;

    return from(
      EsriRequest(url, options)
        .then((result: any) => {
          return result;
        })
        .catch(error => {
          return {
            type: this.CONST.LAYER_ERROR.GET_FIELDS_FROM_LAYER,
            response: error,
          };
        })
    );
  }
}
